<template>
	<div class="footer" style="min-width: 1400px">
		<div class="wrap">
			<div class="fotbox">
				<div class="fotleft">
					<img :src="jiben.fologoimage" class="fologo"/>
					<div class="mabox">
						<img :src="jiben.erlogoimage" class="mapic" alt="">
					</div>
				</div>
				<div class="fotyou">
					<div class="dinav">
						<div class="ditxt" @click="$router.push('/allsearchRefine/xmxqC')">项目需求池</div>
						<div class="ditxt" @click="$router.push('/ResourceTools')">资源工具池</div>
						<div class="ditxt"@click="$router.push('/searchIndex/Solution')">解决方案池</div>
						<div class="ditxt"  @click="$router.push('/searchIndex/productService')">产品服务池</div>
						<div class="ditxt" @click="$router.push('/geniusClub')">牛人俱乐部</div>
					</div>
					<div class="xibox">
						<div class="xili">
							<div class="xitit">
								联系我们
							</div>
							<div class="yinbox">
								<img src="../assets/images/da_14.png" class="yinpic"/>
								<div class="yintxt">
									营销电话：{{jiben.yphone}}
								</div>
							</div>
							<div class="yinbox">
								<img src="../assets/images/db_14.png" class="yinpic"/>
								<div class="yintxt">
									公司地址：{{jiben.address}}
								</div>
							</div>
						</div>
						<div class="diline"></div>
						<div class="xili">
							<div class="xitit">
								合作资源
							</div>
							<div class="zhan">
								<div  
								      class="zhanli"  
								      v-for="(item, index) in hezuo"  
								      :key="index"  
								      @click="navigateToUrl(item.url)"  
								    >  
								      {{ item.name }}  
								</div>  
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="beitxt">
			{{jiben.banquan}} <span @click="navigateToUrl1(jiben.curl)">{{jiben.cname}}</span> 版权所有   经营性ICP/ISP证 备案号:<span @click="navigateToUrl2(jiben.url)">{{jiben.beiannum}}</span>
		</div>
	</div>
</template>

<script>  
export default {  
    name: 'footact',  
    data() {  
        return {  
            hezuo: [],
			jiben:[],
        }  
    },  
    async created() {  
        await this.getHezuoList()
		await this.getJiben()  
    },  
    methods: {  
		async getJiben() {
		    try {  
		        const response = await this.$api.getJiben();  
		        if (response && response.data) {  
		            this.jiben = response.data;  
		            console.log('基本信息', response.data);  
		        } else {  
		            console.error('获取基本信息失败，响应数据不完整', response);  
		        }  
		    } catch (error) {  
		        console.error('获取基本信息时发生错误', error);  
		    }  
		},
        async getHezuoList() {  
            try {  
                const response = await this.$api.getHezuoLists();  
                if (response && response.data) {  
                    this.hezuo = response.data;  
                    console.log('合作资源', response.data);  
                } else {  
                    console.error('获取合作资源失败，响应数据不完整', response);  
                }  
            } catch (error) {  
                console.error('获取合作资源时发生错误', error);  
            }  
        },
		
		navigateToUrl(url) {  
		    window.open(url, '_blank');
		},  
		navigateToUrl1(url) {
		    window.open(url, '_blank');
		}, 
		navigateToUrl2(url) {
		    window.open(url, '_blank');
		}, 
    }  
}  
</script>

<style scoped>

</style>